
(function () {
  const done = new WeakSet();

  function initOne(wrapper){
    if (!wrapper || done.has(wrapper)) return;

    const slider = wrapper.querySelector('.product-image-slider');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll('.product-image-slide'));
    if (!slides.length) return;

    // 1) active state (JS will still control the cycle)
    slides.forEach(s => s.classList.remove('is-active'));
    let i = 0;
    slides[0].classList.add('is-active');

    // 2) arrows
    const arrowsHost = wrapper.querySelector('.custom-arrows');
    if (slides.length > 1 && arrowsHost && !arrowsHost.children.length) {
      arrowsHost.innerHTML =
        '<button class="custom-arrow prev" aria-label="Previous">‹</button>' +
        '<button class="custom-arrow next" aria-label="Next">›</button>';

      const prevBtn = arrowsHost.querySelector('.prev');
      const nextBtn = arrowsHost.querySelector('.next');

      function go(n){
        slides[i].classList.remove('is-active');
        i = (i + n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
      }
      prevBtn.addEventListener('click', (e)=>{ e.preventDefault(); e.stopPropagation(); go(-1); });
      nextBtn.addEventListener('click', (e)=>{ e.preventDefault(); e.stopPropagation(); go(1); });
    }

    // 3) hover auto-cycle
    let timer = null;
    const card = wrapper.closest('.grid-product') || wrapper;

    function start(){
      if (slides.length < 2 || timer) return;
      timer = setInterval(()=> {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, 1200);
    }
    function stop(){
      if (timer){ clearInterval(timer); timer = null; }
      slides[i].classList.remove('is-active');
      i = 0;
      slides[0].classList.add('is-active');
    }
    card.addEventListener('mouseenter', start);
    card.addEventListener('mouseleave', stop);

    // 4) Make the image area navigate to the product link
const mask =
  wrapper.closest('.grid__item-image-wrapper')?.querySelector('.grid-product__image-mask') || wrapper;

const link =
  wrapper.closest('.grid-product__content')?.querySelector('a.grid-product__link');

function isMobile() {
  return window.matchMedia('(max-width: 768px)').matches;
}

function shouldIgnore(ev) {
  return ev.target.closest('.custom-arrow') || ev.target.closest('.bag-icon') || ev.target.closest('button,a,input,select,textarea,label');
}

function goToProduct(ev) {
  if (!link || !mask) return;
  if (shouldIgnore(ev)) return;

  // stop other handlers that may be consuming the first tap
  ev.preventDefault();
  ev.stopPropagation();
  ev.stopImmediatePropagation?.();

  window.location.href = link.href;
}

if (mask && link) {
  mask.style.cursor = 'pointer';

  // desktop
  mask.addEventListener('click', (ev) => {
    if (isMobile()) return; // mobile handled via touchend
    goToProduct(ev);
  });

  // mobile: use touchend so it navigates in a single tap
  mask.addEventListener('touchend', (ev) => {
    if (!isMobile()) return;
    goToProduct(ev);
  }, { passive: false });
}

    done.add(wrapper);
  }

  function scan(ctx){
    (ctx || document).querySelectorAll('.product-image-slider-wrapper').forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', ()=> scan(document));

  // Re-init after filters / AJAX (collections) AND product recommendations on PDP
  [
    'collection:updated','collection:reloaded','facets:updated','facet:updated','ajaxProductFilter:rendered',
    'shopify:section:load',
    'product-recommendations:loaded','product-recommendations:updated'  // ⬅️ important for "You may also like"
  ].forEach(evt => document.addEventListener(evt, e => scan(e.target || document)));

  // Fallback observer if HTML is swapped without events
  const grids = document.querySelectorAll('[data-product-grid], .product-grid, .grid--uniform, product-recommendations');
  grids.forEach((grid) => {
    new MutationObserver(() => scan(grid)).observe(grid, { childList:true, subtree:true });
  });
})();



// mark DOM ready (unchanged)
document.addEventListener('DOMContentLoaded', function () {
  document.documentElement.classList.add('mw-dom-ready');
});


// Quick ADD to cart -----------------------------------
function handleQuickAddClick(e, handle) {
  e.preventDefault();  
  e.stopPropagation(); 
  showQuickAddModal(handle); 
}

// part -2

(() => {
  // Polyfill for CSS.escape (older browsers)
  if (typeof CSS === 'undefined' || typeof CSS.escape !== 'function') {
    window.CSS = window.CSS || {};
    CSS.escape = function (value) { return String(value).replace(/[^a-zA-Z0-9_\-]/g, '\\$&'); };
  }

  const onReady = (fn) => document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", fn)
    : fn();

  onReady(() => {
    // Elements
    const quickAddModal   = document.getElementById("quickAddModal");
    const colorOptionsDiv = document.getElementById("color-options");
    const sizeOptionsDiv  = document.getElementById("size-options");
    const addToBagBtn     = document.getElementById("add-to-bag-btn");
    const viewProductBtn  = document.getElementById("view-product-btn");
    const colorCountSpan  = document.getElementById("color-count");
    const scrollable      = document.querySelector(".quick-add-scrollable");
    const previewImg      = document.getElementById("variant-preview-img");
    const qtyInput        = document.querySelector(".js-modal-qty__num");
    const plusBtn         = document.querySelector(".js-modal-qty__adjust--plus");
    const minusBtn        = document.querySelector(".js-modal-qty__adjust--minus");

    if (!quickAddModal) return;

    let currentProductData = null;
    const selectedOptions = {};
    let activeVariant = null;

    // Bind quantity controls (idempotent)
    function bindQtyControls() {
      if (qtyInput) qtyInput.value = 1; // reset every (re)bind
      if (plusBtn && qtyInput && !plusBtn.dataset.bound) {
        plusBtn.dataset.bound = "1";
        plusBtn.addEventListener("click", () => {
          qtyInput.value = (parseInt(qtyInput.value || "1", 10) + 1).toString();
        });
      }
      if (minusBtn && qtyInput && !minusBtn.dataset.bound) {
        minusBtn.dataset.bound = "1";
        minusBtn.addEventListener("click", () => {
          const n = Math.max(1, parseInt(qtyInput.value || "1", 10) - 1);
          qtyInput.value = n.toString();
        });
      }
    }
    bindQtyControls(); // initial

    // Close modal
    window.closeQuickAddModal = function () {
      quickAddModal.classList.add("hidden");
      quickAddModal.classList.remove("is-open");

      colorOptionsDiv.innerHTML = "";
      sizeOptionsDiv.innerHTML = "";
      document.querySelectorAll(".quick-add-options.extra-option").forEach(el => el.remove());
      if (colorCountSpan) colorCountSpan.innerText = "0";

      addToBagBtn.disabled = true;
      addToBagBtn.onclick = null; // clear previous variant handler

        // ✅ Reset button state & text/icon
  if (addToBagBtn) {
    addToBagBtn.classList.remove("active", "added");

    const desktopText = addToBagBtn.querySelector(".btn-text.desktop-only");
    const mobileIcon = addToBagBtn.querySelector(".btn-icon.mobile-only");

    if (desktopText) {
  desktopText.textContent = "Add to Bag";
  desktopText.classList.remove("slide-in", "slide-out");
}
if (mobileIcon) {
  mobileIcon.src = "https://ministerwhite.com/cdn/shop/t/28/assets/add-to-cart-white.png?v=102375225090545128931756382573";
  mobileIcon.classList.remove("slide-in", "slide-out");
}

  }

      Object.keys(selectedOptions).forEach(k => delete selectedOptions[k]);
      activeVariant = null;

      if (previewImg) { previewImg.src = ""; previewImg.style.display = "none"; }
      if (qtyInput) qtyInput.value = 1; // ensure reset on close too
       document.body.classList.remove("no-scroll"); 
    };

    // Open modal
    window.showQuickAddModal = function (handle) {
      if (!handle) return;

      fetch(`/products/${handle}.js`)
        .then(res => { if (!res.ok) throw new Error("Fetch failed"); return res.json(); })
        .then(data => {
          currentProductData = data;

          // Show modal
          quickAddModal.classList.remove("hidden");
          quickAddModal.classList.add("is-open");
          quickAddModal.setAttribute("aria-hidden", "false");

          // Reset UI/State
          Object.keys(selectedOptions).forEach(k => delete selectedOptions[k]);
          addToBagBtn.disabled = true;
          addToBagBtn.onclick = null;
          if (viewProductBtn) viewProductBtn.href = `/products/${handle}`;
          if (qtyInput) qtyInput.value = 1; // reset to 1 on open

          if (previewImg) {
            previewImg.src = (data.images && data.images[0]) || "";
            previewImg.style.display = previewImg.src ? "inline-block" : "none";
          }

          renderOptions(data);
          autoSelectSingleValueOptions();
          bindQtyControls(); // re-ensure qty listeners exist and value=1
        })
        .catch(() => {});
        document.body.classList.add("no-scroll");
    };

    // Delegated trigger (works even without inline onclick)
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(".bag-icon");
      if (!trigger) return;
      const handle = trigger.dataset.handle;
      if (handle) window.showQuickAddModal(handle);
    });

    // ESC to close
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") window.closeQuickAddModal();
    });

    // Render options
    function renderOptions(product) {
      const options = product.options;
      const variants = product.variants;
      const availableVariants = variants.filter(v => v.available);

      const optionMap = {};
      const availableMap = {};

      options.forEach((opt, idx) => {
        optionMap[opt.name]   = [...new Set(variants.map(v => String(v.options[idx]).trim()))];
        availableMap[opt.name]= new Set(availableVariants.map(v => String(v.options[idx]).trim()));
      });

      const keys = Object.keys(optionMap);
      const colorKey = keys.find(k => /color|border|shade/i.test(k));
      const sizeKey  = keys.find(k => /size/i.test(k) && !/color/i.test(k));
      const otherKeys= keys.filter(k => k !== colorKey && k !== sizeKey);

      document.querySelectorAll(".quick-add-options.extra-option").forEach(el => el.remove());

      if (colorKey) {
        if (colorCountSpan) colorCountSpan.innerText = optionMap[colorKey].length;
        colorOptionsDiv.innerHTML = optionMap[colorKey].map(val => {
          const label = String(val).trim();
          const isAvail = availableMap[colorKey].has(label);
          return `<button class="swatch-btn ${!isAvail ? 'disabled' : ''}" data-type="${colorKey}" data-value="${label}" ${!isAvail ? 'disabled title="Not available"' : ''}>${label}</button>`;
        }).join("");
      } else {
        colorOptionsDiv.innerHTML = "";
        if (colorCountSpan) colorCountSpan.innerText = "0";
      }

      if (sizeKey) {
        sizeOptionsDiv.innerHTML = optionMap[sizeKey].map(val => {
          const label = String(val).trim();
          const isAvail = availableMap[sizeKey].has(label);
          return `<button class="swatch-btn ${!isAvail ? 'disabled' : ''}" data-type="${sizeKey}" data-value="${label}" ${!isAvail ? 'disabled title="Not available"' : ''}>${label}</button>`;
        }).join("");
      } else {
        sizeOptionsDiv.innerHTML = "";
      }

      otherKeys.forEach(key => {
        const container = document.createElement("div");
        container.className = "quick-add-options extra-option";
        const buttons = optionMap[key].map(val => {
          const label = String(val).trim();
          const isAvail = availableMap[key].has(label);
          return `<button class="swatch-btn ${!isAvail ? 'disabled' : ''}" data-type="${key}" data-value="${label}" ${!isAvail ? 'disabled title="Not available"' : ''}>${label}</button>`;
        }).join("");
        container.innerHTML = `<h3 class="quick-add-title">${key}</h3>${buttons}`;
        scrollable.appendChild(container);
      });

      attachOptionListeners();
      updateOptionAvailability();
    }

    function onSwatchClick(e) {
      const btn   = e.currentTarget;
      const type  = btn.dataset.type;
      const value = btn.dataset.value;
      document.querySelectorAll(`.swatch-btn[data-type="${CSS.escape(type)}"]`).forEach(b => b.classList.remove("selected"));
      btn.classList.add("selected");
      selectedOptions[type] = value;
      validateSelections();
      updateOptionAvailability();
    }

    function attachOptionListeners() {
      document.querySelectorAll(".swatch-btn").forEach(btn => {
        if (btn.dataset.bound === "1" || btn.classList.contains("disabled")) return;
        btn.dataset.bound = "1";
        btn.addEventListener("click", onSwatchClick);
      });
    }

    function updateOptionAvailability() {
      if (!currentProductData) return;
      const names = currentProductData.options.map(o => o.name);
      const variants = currentProductData.variants;

      names.forEach((name) => {
        const btns = document.querySelectorAll(`.swatch-btn[data-type="${CSS.escape(name)}"]`);
        btns.forEach(btn => {
          const testValue = btn.dataset.value;
          const testSel = { ...selectedOptions, [name]: testValue };

          const isAvail = variants.some(variant =>
            variant.available &&
            variant.options.every((ov, i) => {
              const chosen = testSel[names[i]];
              return !chosen || String(ov) === String(chosen);
            })
          );

          if (!isAvail) { btn.classList.add("disabled"); btn.setAttribute("disabled", "true"); }
          else { btn.classList.remove("disabled"); btn.removeAttribute("disabled"); }
        });
      });
    }

    // Auto-select any option group with only ONE enabled value
function autoSelectSingleValueOptions() {
  if (!currentProductData) return;

  const optionNames = currentProductData.options.map(o => o.name);

  optionNames.forEach(name => {
    const btns = document.querySelectorAll(
      `.swatch-btn[data-type="${CSS.escape(name)}"]`
    );

    // Only enabled ones count
    const enabledBtns = [...btns].filter(b => !b.classList.contains("disabled"));

    if (enabledBtns.length === 1) {
      const btn = enabledBtns[0];
      btn.classList.add("selected");
      selectedOptions[name] = btn.dataset.value;
    }
  });

  validateSelections();
  updateOptionAvailability();
}
// end default select

    function validateSelections() {
      if (!currentProductData) return;
      const names = currentProductData.options.map(o => o.name);
      const allChosen = names.every(n => !!selectedOptions[n]);

      if (!allChosen) { addToBagBtn.disabled = true; activeVariant = null; addToBagBtn.onclick = null; return; }

      const match = currentProductData.variants.find(v =>
        v.options.every((ov, i) => String(ov) === String(selectedOptions[names[i]]))
      );

      activeVariant = match || null;

if (match && match.available) {
  addToBagBtn.disabled = false;
  addToBagBtn.classList.add("active"); 
  addToBagBtn.onclick = () => addToCart(match.id);
} else {
  addToBagBtn.disabled = true;
  addToBagBtn.classList.remove("active");
  addToBagBtn.onclick = null;
}
    }

    // Add to cart (latest Impulse compatible; drawer refresh handled by theme)
function addToCart(variantId) {
  if (!variantId) return;

  const qtyInput = document.querySelector(".js-modal-qty__num");
  const quantity = Math.max(1, parseInt(qtyInput?.value || "1", 10));

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    },
    credentials: "same-origin",
    body: JSON.stringify({ id: variantId, quantity })
  })
  .then(async (res) => {
    const text = await res.text();
    if (!res.ok) throw new Error(text || "Add to cart failed");
    return JSON.parse(text);
  })
  .then(() => {
    // Close quick-add (safe if not present)
    // Animate button to show "Added"
addToBagBtn.classList.add("animating");

const desktopText = addToBagBtn.querySelector(".btn-text.desktop-only");
const mobileIcon = addToBagBtn.querySelector(".btn-icon.mobile-only");

// Add slide-out class first
if (desktopText) desktopText.classList.add("slide-out");
if (mobileIcon) mobileIcon.classList.add("slide-out");

// Wait for slide-out animation (300ms), then swap content
setTimeout(() => {
  if (desktopText) {
    desktopText.textContent = "Added";
    desktopText.classList.remove("slide-out");
    desktopText.classList.add("slide-in");
  }

  if (mobileIcon) {
    mobileIcon.src = "https://cdn.shopify.com/s/files/1/0470/0389/3911/files/added-icon.png?v=1756891792";
    mobileIcon.classList.remove("slide-out");
    mobileIcon.classList.add("slide-in");
  }
}, 300);

// Wait 1 second to show "Added" before closing modal
setTimeout(() => {
  if (typeof window.closeQuickAddModal === "function") closeQuickAddModal();
}, 1300);


    // Nudge Impulse/Theme (non-blocking)
    try { document.dispatchEvent(new CustomEvent("cart:build")); } catch(_) {}
    try { document.dispatchEvent(new CustomEvent("cart:updated")); } catch(_) {}

    // Shiprocket Smart Cart refresh (if app present)
    try {
      if (typeof window.cooeeUpdateCartDrawer === "function") {
        window.cooeeUpdateCartDrawer();
      } else if (typeof window.updateMiniCartSection === "function") {
        window.updateMiniCartSection();
      }
    } catch(_) {}

    // Pull fresh cart, then toggle the header bubble
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
      .then(r => r.json())
      .then(cart => {
        // Broadcast for any other listeners
        try { document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart })); } catch(_) {}

        // 🔔 Update your dot bubble(s)
        const bubbles = document.querySelectorAll(".cart-link__bubble");
        bubbles.forEach(bub => {
          if (cart.item_count > 0) {
            bub.classList.add("cart-link__bubble--visible");
          } else {
            bub.classList.remove("cart-link__bubble--visible");
          }
        });
      });
  })
  .catch((err) => {
    console.error("Add to cart error:", err);
    alert("Error adding to cart. Please try again.");
  });
}

  });
})();

// Sticky add to cart ------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  // --- Guard: only on PDPs ---
  const isPDP =
    document.body.classList.contains("template-product") ||
    /\/products\//.test(window.location.pathname);
  if (!isPDP) return;

  // --- Elements ---
  const stickyBar     = document.getElementById("stickyAddToCartBar");
  if (!stickyBar) return;

  const variantData   = window.productVariants || [];
  const selects       = stickyBar.querySelectorAll(".option-select");
  const qtyInput      = stickyBar.querySelector(".js-qty__num");
  const minusBtn      = stickyBar.querySelector(".js-qty__adjust--minus");
  const plusBtn       = stickyBar.querySelector(".js-qty__adjust--plus");
  const addToCartBtn  = document.getElementById("stickyAddToCartBtn");

  // --- Reset qty & de-dupe +/- listeners ---
  if (qtyInput) qtyInput.value = "1";
  if (plusBtn)  plusBtn.replaceWith(plusBtn.cloneNode(true));
  if (minusBtn) minusBtn.replaceWith(minusBtn.cloneNode(true));
  const newPlusBtn  = stickyBar.querySelector(".js-qty__adjust--plus");
  const newMinusBtn = stickyBar.querySelector(".js-qty__adjust--minus");

  if (newPlusBtn && qtyInput) {
    newPlusBtn.addEventListener("click", () => {
      const n = parseInt(qtyInput.value || "1", 10);
      qtyInput.value = (isNaN(n) ? 1 : n + 1).toString();
    });
  }
  if (newMinusBtn && qtyInput) {
    newMinusBtn.addEventListener("click", () => {
      const n = parseInt(qtyInput.value || "1", 10);
      qtyInput.value = Math.max(1, isNaN(n) ? 1 : n - 1).toString();
    });
  }

  // --- Helpers: options/variants ---
  function getSelectedOptions() {
    return Array.from(selects).map(s => s.value || "");
  }

  function findMatchingVariant() {
    const selected = getSelectedOptions();
    return variantData.find(v => v.options.every((opt, i) => opt === selected[i]));
  }

  function optionIsPossible(testIndex, testValue, currentSelection) {
    const sel = currentSelection.slice();
    sel[testIndex] = testValue;
    return variantData.some(v =>
      v.available && v.options.every((opt, i) => sel[i] === "" || sel[i] === opt)
    );
  }

  function updateOptionsAvailability() {
    const current = getSelectedOptions();
    selects.forEach((select, idx) => {
      select.querySelectorAll("option").forEach((opt) => {
        const val = opt.value;
        if (val === "") { opt.disabled = false; return; }
        opt.disabled = !optionIsPossible(idx, val, current);
      });

      // If current choice became impossible, pick first enabled or ""
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.disabled) {
        const firstEnabled = Array.from(select.options)
          .find(o => !o.disabled && o.value !== "");
        select.value = firstEnabled ? firstEnabled.value : "";
      }
    });
  }

  function updateAddToCartState() {
    const variant = findMatchingVariant();
    if (variant && variant.available) {
      addToCartBtn.disabled = false;
      addToCartBtn.setAttribute("data-variant-id", variant.id);
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.removeAttribute("data-variant-id");
    }
  }

  // --- Wire dropdowns + initial state ---
  selects.forEach(select => {
    select.addEventListener("change", () => {
      updateOptionsAvailability();
      updateAddToCartState();
    });
  });
  updateOptionsAvailability();
  updateAddToCartState();

  // --- Optional drawer opener (Impulse fallback) ---
  function openCartDrawer(){
    try { document.dispatchEvent(new CustomEvent('cart:open')); } catch(_) {}
    const opener =
      document.querySelector('[data-open-drawer="cart"]') ||
      document.querySelector('[data-drawer-open="cart"]') ||
      document.querySelector('.js-drawer-open-cart');
    if (opener) { opener.click(); return; }
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
      document.documentElement.classList.add('js-drawer-open');
      document.body.classList.add('js-drawer-open','drawer-is-open');
      drawer.classList.add('is-open');
    }
  }

  // --- ADD TO CART (mirrors your working modal sequence) ---
  addToCartBtn?.addEventListener("click", () => {
    const variantId = addToCartBtn.getAttribute("data-variant-id");
    const quantity  = Math.max(1, parseInt(qtyInput?.value || "1", 10));
    if (!variantId || !quantity) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      credentials: "same-origin",
      body: JSON.stringify({ id: variantId, quantity })
    })
    .then(async (res) => {
      const text = await res.text();
      if (!res.ok) throw new Error(text || "Add to cart failed");
      return JSON.parse(text); // added line item
    })
    .then((addedItem) => {
      // Emit the same signals as your working modal
      try { document.dispatchEvent(new CustomEvent("product:added", { detail: addedItem })); } catch(_) {}
      try { document.dispatchEvent(new CustomEvent("cart:build")); } catch(_) {}
      try { document.dispatchEvent(new CustomEvent("cart:updated")); } catch(_) {}

      // Open the cart drawer (optional; helps user see it update)
      openCartDrawer();

      // Vendor hooks you already use elsewhere
      try {
        if (typeof window.cooeeUpdateCartDrawer === "function") {
          window.cooeeUpdateCartDrawer();
        } else if (typeof window.updateMiniCartSection === "function") {
          window.updateMiniCartSection();
        }
      } catch(_) {}

      // Pull fresh cart and broadcast (your modal does this; do same here)
      return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
        .then(r => r.json())
        .then(cart => {
          try { document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart })); } catch(_) {}
          try { window.postMessage({ type: "SHOPIFY_CART_UPDATED", cart }, "*"); } catch(_) {}

          // Update header bubbles if present
          const bubbles = document.querySelectorAll(".cart-link__bubble");
          bubbles.forEach(bub => {
            if (cart.item_count > 0) {
              bub.classList.add("cart-link__bubble--visible");
            } else {
              bub.classList.remove("cart-link__bubble--visible");
            }
          });
        });
    })
    .catch((err) => {
      console.error("Sticky add to cart error:", err);
      // Optional: toast UI
      // alert("Error adding to cart. Please try again.");
    });
  });

  // --- Sticky bar visibility ---
  window.addEventListener('scroll', () => {
    const isMobile = window.innerWidth <= 768;
    const triggerEl = isMobile
      ? document.querySelector(".product-block--header")
      : document.querySelector(".social-sharing");
    if (!triggerEl) return;

    const triggerBottom = triggerEl.getBoundingClientRect().bottom;
    if (triggerBottom < 0) stickyBar.classList.remove("hidden");
    else stickyBar.classList.add("hidden");
  });
});

// =--------------------------------------------------

// footer custom APP
document.addEventListener("DOMContentLoaded", function () {
  const appBlock = document.querySelector(".footer__item--custom_BaHnpT");
  if (appBlock) {
    appBlock.innerHTML = `
   <div class="app-download-section">
  <h3>Download Our App For The Best Shopping Experience.</h3>
  <div class="app-badges">
    <a href="https://play.google.com/store/apps/details?id=com.ministerwhite&hl=en_IN" target="_blank" rel="noopener">
      <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" />
    </a>
    <a href="https://apps.apple.com/in/app/minister-white/id1643480817" target="_blank" rel="noopener">
      <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" />
    </a>
  </div>
</div>

    `;
  }
});


// click on the zoom button

document.addEventListener("DOMContentLoaded", function () {
    const image = document.querySelector('.product-image-main');
    const zoomButton = document.querySelector('.btn.js-photoswipe__zoom');

    if (!image || !zoomButton) return;

    function isMobile() {
        return window.innerWidth <= 768;
    }

    // Add click listener ONLY once
    image.addEventListener('click', function () {
        if (isMobile()) {
            zoomButton.click();

            // Safety: restore scroll after PhotoSwipe closes
            setTimeout(restoreScroll, 300);
        }
    });

    function restoreScroll() {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        document.body.classList.remove('photoswipe--open', 'modal-open');
    }
});

